<template>
  <div v-if="show" class="notification-banner" style="border: 0; border-radius: 0; display: grid; grid-template-columns: 1fr auto;">
    <div class="notification-content" style="display: grid; justify-content: center; align-items: center;">
      <h4 style="font-size: 30px; margin: 0; color: #fff;">{{ notification.title }}</h4>
      <p style="font-size: 14px;">{{ notification.message }}</p>
      <!-- <p v-if="notification.countdownDays">Days left: {{ notification.countdownDays }}</p> -->
    </div>
    <div class="notification-actions mt-2">
      <button className="btn btn-primary" style="border: 0; background-color: #fff; border-radius: 4px; padding: 4px 6px;" @click="handleAction('acknowledged')">Acknowledge</button>
      <button className="btn btn-secondary" style="border: 0; background-color: #fff; border-radius: 4px; padding: 4px 6px;" @click="handleAction('dismissed')">Dismiss</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MigrationNotificationBanner',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    notification: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleAction(action) {
      this.$emit('action', this.notification.type, action);
    },
  },
};
</script>

<style scoped>
.notification-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #721c24;
  color: #fff;
  padding: 1rem;
  border: 1px solid #f5c6cb;
  border-radius: 0.25rem;
  margin: 0px;
}

.notification-content {
  flex-grow: 1;
}

.notification-actions button {
  margin-left: 1rem;
}
</style>
